const data = [
  { name: "7 Days", uv: 4000, price: 2400, amt: 2400 },
  { name: "15 Days", uv: 3000, price: 1398, amt: 2210 },
  { name: "30 Days", uv: 2000, price: 9800, amt: 2290 },
];
export default data;
